import api from "../../utils/api";
import { apiPath } from "../../utils/apiPath";
import { showApiErrorToast } from "../../utils/toastErrorHandler";

// GET List API
export async function tasksListApi(payload) {
  // Ensure we pass params correctly
  return await api.get(`${apiPath.API_URL}${apiPath.tasks.getTask}`, {
    params: payload,
  });
}

// POST Create API
export async function createTasksApi(payload) {
  try {
    const response = await api.post(
      apiPath.tasks.addTask,
      payload, // Send payload directly as the body
      { headers: { "Content-Type": "application/json" } },
    );
    return response.data;
  } catch (error) {
    console.error("Create Task Error:", error);
    throw showApiErrorToast(error.response?.data);
  }
}

export async function supportTeamTaskCreateApi(payload) {
  try {
    const response = await api.post(
      apiPath.tasks.supportTeamTaskCreate,
      payload, // Send payload directly as the body
      { headers: { "Content-Type": "application/json" } },
    );
    return response.data;
  } catch (error) {
    console.error("Create Task Error:", error);
    throw showApiErrorToast(error.response?.data);
  }
}


// POST Create API
export async function tasksAssignApi(payload) {
  try {
    const response = await api.post(
      apiPath.tasks.tasksAssign,
      payload, // Send payload directly as the body
      { headers: { "Content-Type": "application/json" } },
    );
    return response.data;
  } catch (error) {
    console.error("Create Task Error:", error);
    throw showApiErrorToast(error.response?.data);
  }
}

export async function projectMenuApi(payload) {
  // Ensure we pass params correctly
  return await api.get(`${apiPath.API_URL}${apiPath.tasks.projectMenu}`, {
    params: payload,
  });
}

export async function clientMenuApi(payload) {
  return await api.get(`${apiPath.API_URL}${apiPath.tasks.clientMenu}`, {
    params: payload,
  });
}

export async function mainMenuApi(payload) {
  return await api.get(`${apiPath.API_URL}${apiPath.tasks.mainMenuApi}`, {
    params: payload,
  });
}

export async function submenu1Api(payload) {
  return await api.get(`${apiPath.API_URL}${apiPath.tasks.submenu1Api}`, {
    params: payload,
  });
}

export async function submenu2Api(payload) {
  return await api.get(`${apiPath.API_URL}${apiPath.tasks.submenu2Api}`, {
    params: payload,
  });
}

export async function submenu3Api(payload) {
  return await api.get(`${apiPath.API_URL}${apiPath.tasks.submenu3Api}`, {
    params: payload,
  });
}

export async function submenu4Api(payload) {
  return await api.get(`${apiPath.API_URL}${apiPath.tasks.submenu4Api}`, {
    params: payload,
  });
}



export async function updateDevelopmentTasksApi(payload) {
  try {
    const response = await api.put(
      `${apiPath.tasks.updateDevelopmentTask}`, // Ensure this path points to /api/v1/tasks-development/update
      payload,
      { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
  } catch (error) {
    console.error("Update Task Error:", error);
    throw showApiErrorToast(error.response?.data);
  }
}

export async function createStatusTrackerApi(payload) {
  try {
    const response = await api.post(
      `${apiPath.tasks.createStatusTracker}`, 
      payload,
      { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
  } catch (error) {
    console.error("Update Task Error:", error);
    throw showApiErrorToast(error.response?.data);
  }
}

export async function getTaskAssignmentApi(params) {
  return await api.get(`${apiPath.API_URL}${apiPath.tasks.getTaskAssignment}`, {
    params: params, // Axios will correctly format: ?isManuallyRaised=1&currentPage=1...
  });
}

export async function getTaskDevelopmentApi(params) {
  return await api.get(`${apiPath.API_URL}${apiPath.tasks.getTaskDevelopment}`, {
    params: params, // Axios will correctly format: ?isManuallyRaised=1&currentPage=1...
  });
}

export async function raisedbyDetailsApi(params) {
  return await api.get(`${apiPath.API_URL}${apiPath.tasks.raisedbyDetails}`, {
    params: params, // Axios will correctly format: ?isManuallyRaised=1&currentPage=1...
  });
}

export async function lastEndTimesApi(params) {
  return await api.get(`${apiPath.API_URL}${apiPath.tasks.lastEndTime}`, {
    params: params, // Axios will correctly format: ?isManuallyRaised=1&currentPage=1...
  });
}

export async function supportTeamTaskListApi(params) {
  return await api.get(`${apiPath.API_URL}${apiPath.tasks.supportTeamTaskList}`, {
    params: params, // Axios will correctly format: ?isManuallyRaised=1&currentPage=1...
  });
}


export async function historyListAPI(params) {
  return await api.get(`${apiPath.API_URL}${apiPath.tasks.historyList}`, {
    params: params, // Axios will correctly format: ?isManuallyRaised=1&currentPage=1...
  });
}

/* Where a query came from — CLIENT SIDE or OWN. A two-row lookup, fetched
   once when the task form opens. */
export async function queryFromApi(payload) {
  return await api.get(`${apiPath.API_URL}${apiPath.tasks.queryFrom}`, {
    params: payload,
  });
}
